/**
 *  Define a token for the ILoggerService interface
 */
export const IConfigurationSourceToken = 'IConfigurationSourceToken';
/**
 *  Define a token for the ILoggerService interface
 */
export const IConfigurationToken = 'IConfigurationToken';
// Helper function to iterate over a configuration object and yield key-value pairs
export function* iterateConfig(obj, prefix = '') {
    for (const [key, value] of Object.entries(obj)) {
        const fullKey = prefix ? `${prefix}:${key}` : key;
        // Check if the value is an array
        if (Array.isArray(value)) {
            for (let i = 0; i < value.length; i++) {
                const item = value[i];
                // For each item in the array, extend the prefix to include the index
                if (typeof item === 'object' && item !== null) {
                    // Recursively yield nested object values, including arrays
                    yield* iterateConfig(item, `${fullKey}:${i}`);
                }
                else {
                    // Yield primitive values directly, with index in the key
                    yield { key: `${fullKey}:${i}`, value: item };
                }
            }
        }
        else if (typeof value === 'object' && value !== null) {
            // Recursively yield nested object values
            yield* iterateConfig(value, fullKey);
        }
        else {
            // Yield primitive values directly
            yield { key: fullKey, value };
        }
    }
}
//# sourceMappingURL=IConfiguration.js.map